import { Link } from "react-router-dom";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import USPs from "components/USPs";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";
import { Helmet } from "react-helmet-async";

export default function Home() {
  const { DiscoverCTA, resellerCTA, becomeResellerCTA, brandName } =
    brandConfig;
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil" }]);
  }, [setItems]);
  return (
    <>
      <Helmet>
        <link
          rel="preload"
          as="image"
          href="/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-herobanner.webp"
          fetchPriority="high"
        />
      </Helmet>
      <SEOMeta
        title="Acceuil"
        description={`${brandName} est une marque suisse dédiée aux armoires à fusils sécurisées. Découvrez notre gamme grâce aux conseils de nos revendeurs experts et de notre réseau de revendeurs certifiés.`}
        suffixBrand={false}
      />
      {/* HERO */}
      <section className="hero">
        <div className="hero__inner container">
          {/* Colonne gauche : contenu sur fond blanc */}
          <div className="hero__content">
            <h1>The TresorSafe</h1>
            <p className="hero__lead">
              Marque dédiée aux armoires à fusils sécurisées. Découvrez notre
              gamme et nos revendeurs agréés.
            </p>

            <div className="hero__cta">
              <Link to={DiscoverCTA.path} className="btn">
                {DiscoverCTA.label}
              </Link>
              <Link
                to={resellerCTA.path}
                className="btn btn-secondary btn-ghost"
                aria-label="Trouver un revendeur"
              >
                {resellerCTA.label}
              </Link>
            </div>

            <div className="hero__subcta">
              <Link className="btn btn-ghost" to={becomeResellerCTA.path}>
                {becomeResellerCTA.label}
              </Link>
            </div>
          </div>

          {/* Colonne droite : image produit */}
          <div className="hero__media" aria-hidden="true">
            <img
              className="hero__product"
              src="/TS6/armoire-a-fusils-tresorsafe-6-armes-serrure-a-cles-herobanner.webp"
              alt="Armoire à fusils TresorSafe 6 armes"
              loading="eager"
              decoding="async"
              width={520}
              height={520}
              fetchPriority="high"
            />
          </div>
        </div>
      </section>
      {/* USPs */}
      <USPs />
    </>
  );
}
